import { render, staticRenderFns } from "./DeclarationAgreements.vue?vue&type=template&id=a72230f6&scoped=true"
import script from "./DeclarationAgreements.vue?vue&type=script&lang=js"
export * from "./DeclarationAgreements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72230f6",
  null
  
)

export default component.exports